export const Divider = () => {
    return <hr className="w-full h-px bg-primary-black/20 border-0" />;
};
